import { Button, Stack, Tooltip } from "@mantine/core";
import { useMemo } from "react";
import { useFlowStore } from "../../../../../../stores/WorkflowStore";
import { getNodeDetails } from "../flowSettings";
import { useReactFlow } from "reactflow";

const PanelClosedContent = () => {
  const nodes = useFlowStore((s) => s.nodes);

  const actionNodes = useMemo(() => {
    return nodes.filter(
      (x) =>
        x?.data?.actionType?.includes("email") ||
        x?.data?.actionType?.includes("linkedin") ||
        x?.data?.actionType?.includes("sms")
    );
  }, [nodes]);

  const reactFlow = useReactFlow();
  const setSelectedNode = useFlowStore((s) => s.setSelectedNode);
  const handleClick = (node) => {
    setSelectedNode(node);
    setTimeout(() => {
      reactFlow?.setCenter(node.x + 128, node.y + 132, {
        duration: 200,
        zoom: 1,
      });
    }, 250);
  };

  return (
    <Stack p={"xs"}>
      {actionNodes.map((item) => {
        let props = getNodeDetails(item.data?.actionType, { size: 32 });
        return (
          <Tooltip
            position="left"
            key={item.id}
            label={`#${item.id} ${props.label}`}
          >
            <Button
              key={item.id}
              color={props.color}
              onClick={() => handleClick(item)}
              variant="light"
              size={"xl"}
              radius={"md"}
              miw={0}
              w={48}
              p={0}
              h={48}
            >
              {props.icon}
            </Button>
          </Tooltip>
        );
      })}
    </Stack>
  );
};

export default PanelClosedContent;
